import { defineMessages, IntlShape } from "react-intl";

import PinLegendVisibility from "@mapmycustomers/shared/enum/pinLegends/PinLegendVisibility";

import { getDisplayName } from "./getDisplayName";

export const visibilityNotes = defineMessages<PinLegendVisibility>({
  [PinLegendVisibility.PRIVATE]: {
    id: "pinLegendVisibility.private.note",
    defaultMessage: "Only you can apply this legend.",
    description: "Visibility note for Private VISIBILITY TYPE option",
  },
  [PinLegendVisibility.SHARED_WITH_ORGANIZATION]: {
    id: "pinLegendVisibility.sharedWithOrganization.note",
    defaultMessage: "Users on any team, regardless of role, can apply this legend.",
    description: "Visibility note for Shared with ORGANIZATION VISIBILITY TYPE option",
  },
  [PinLegendVisibility.SHARED_WITH_TEAM]: {
    id: "pinLegendVisibility.sharedWithTeam.note",
    defaultMessage: "Users of only the teams selected below can apply this legend.",
    description: "Visibility note for Shared with team VISIBILITY TYPE option",
  },
});

const getPinLegendVisibilityNote = (intl: IntlShape, pinLegendVisibility: PinLegendVisibility) =>
  getDisplayName(intl, visibilityNotes, pinLegendVisibility, "PinLegendVisibility");

export default getPinLegendVisibilityNote;
